import getContentAreaFromSpread from 'editor/src/store/design/util/getContentAreaFromSpread';
import getCurrentSpreadIndex from 'editor/src/store/editor/selector/getCurrentSpreadIndex';
import getFocusedContent from 'editor/src/store/editor/selector/getFocusedContent';
import getRollLength from 'editor/src/store/gangSheet/selector/getRollLength';
import getSheetArtworkRects from 'editor/src/store/gangSheet/util/getSheetArtworkRects';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import { getArtworkLengthMm } from 'editor/src/util/gangSheet/rollingSheetLength';

import setSheetLengthOperation from './setSheetLengthOperation';

// Runs after every design change on a rolling gang sheet: the sheet's length follows its
// artwork. It grows when artwork reaches past the bottom edge (added, duplicated or dragged
// down) and shrinks when artwork is removed or moved up, within the host's limits. Only the
// bottom edge moves; artwork never does. It also runs when a design loads, which clamps a
// template outside the limits and records the sheet's size on a template that carries none.
const fitSheetToArtworkOperation = () => (dispatch: ThunkDispatch, getState: () => RootState) => {
  const state = getState();
  if (!getRollLength(state)) {
    return;
  }
  const spread = state.design.designData?.spreads[getCurrentSpreadIndex(state)];
  const area = getContentAreaFromSpread(spread, getFocusedContent(state));
  if (!area) {
    return;
  }

  dispatch(setSheetLengthOperation(getArtworkLengthMm(getSheetArtworkRects(spread, area))));
};

export default fitSheetToArtworkOperation;
